import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import _toConsumableArray from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js";
import "core-js/modules/web.dom.iterable";
import _defineProperty from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { ModalFormMixin } from '@/mixins/ModalFormMixin';
import { httpAction, getAction } from '@/api/manage';
import pick from 'lodash.pick';
import { queryFactorList as _queryFactorList } from '@/api/api';
var columnsItem = [{
  title: '因子ID',
  dataIndex: 'factorId',
  align: 'center',
  width: '30%',
  scopedSlots: {
    customRender: 'factorId'
  }
}, {
  title: '序号',
  align: 'center',
  dataIndex: 'sort',
  width: '10%',
  scopedSlots: {
    customRender: 'sort'
  }
}, {
  title: '操作',
  width: '10%',
  align: 'center',
  dataIndex: 'operation',
  scopedSlots: {
    customRender: 'operation'
  }
}];
var dataItem = []; // PS相关的KEY不能为title关键字

var addDataIndex = 0;
export default {
  name: 'FactorGroupModal',
  mixins: [ModalFormMixin],
  data: function data() {
    this.cacheData = dataItem.map(function (item) {
      return _objectSpread({}, item);
    });
    return {
      dataItem: dataItem,
      columnsItem: columnsItem,
      addDataIndex: addDataIndex,
      factorOptions: [],
      title: '环境监测因子组表单',
      tableName: 'site_factor_group',
      form_fields: ['code', 'title', 'status', 'sort', 'remark', 'tenantId'],
      form_fields_time: [],
      validatorRules: {
        code: {
          rules: [{
            required: true,
            message: '请输入编号!'
          }]
        },
        title: {
          rules: [{
            required: true,
            message: '请输入名称!'
          }]
        },
        status: {
          rules: [{
            required: true,
            message: '请输入状态!'
          }]
        },
        sort: {
          rules: [{
            required: true,
            message: '请输入排序号!'
          }]
        }
      } // url: {
      //   add: '/site/factor/group',
      //   edit: '/site/factor/group'
      // }

    };
  },
  props: ['pagePath'],
  created: function created() {
    this.queryFactorList();
  },
  methods: {
    edit: function edit(record) {
      var _this = this;

      this.dataItem = [];
      this.addDataIndex = 1;
      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;
      this.queryFactorGroupItemList();
      this.$nextTick(function () {
        var that = _this; //debugger

        that.form.setFieldsValue(pick(that.model, that.form_fields)); //时间格式化

        var timeVal = {};
        that.form_fields_time.forEach(function (item, index) {
          timeVal[item] = that.model[item] ? moment(that.model[item]) : null;
        });
        that.form.setFieldsValue(timeVal);
      });
    },
    queryFactorGroupItemList: function queryFactorGroupItemList() {
      var that = this;
      var params = {
        pageNo: 1,
        pageSize: 10000,
        groupId: this.model.id
      };
      getAction('/site/factor/group/item', params).then(function (res) {
        if (res.success) {
          var paramList = [];

          for (var i = 0; i < res.result.records.length; i++) {
            var param = res.result.records[i];
            param.key = param.id;
            param.editable = false;
            paramList.push(param);
          }

          that.dataItem = paramList;
        }
      });
    },
    // 获取因子
    queryFactorList: function queryFactorList() {
      var that = this;
      var params = {
        pageNo: 1,
        pageSize: 10000,
        status: '1'
      };

      _queryFactorList(params).then(function (res) {
        if (res.success) {
          that.factorOptions = res.result.records;
        }
      });
    },

    /**
     * 获取选中值
     * @param value
     */
    handleChange: function handleChange(value) {
      console.log("selected ".concat(value));
      this.columnsItem.factorId = value;
      console.log(this.form);
    },

    /**
     * 监测因子过滤
     * @param input
     * @param option
     * @returns {boolean}
     */
    filterOption: function filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    close: function close() {
      this.$emit('close');
      this.visible = false;
    },
    handleOk: function handleOk() {
      var _this2 = this;

      var that = this; // 触发表单验证

      this.form.validateFields(function (err, values) {
        if (!err) {
          that.confirmLoading = true;
          var httpurl = '';
          var method = '';

          if (!_this2.model.id) {
            httpurl = _this2.url.add ? _this2.url.add : _this2.pagePath;
            method = 'post';
          } else {
            httpurl = _this2.url.edit ? _this2.url.edit : _this2.pagePath;
            method = 'put';
          }

          var formData = Object.assign(_this2.model, values);
          formData.factorGroupItemList = _this2.dataItem; //时间格式化

          console.log(formData);
          httpAction(httpurl, formData, method).then(function (res) {
            if (res.success) {
              that.$notification.success({
                message: res.message
              });
              that.$emit('ok');
              that.close();
            } else {
              that.$notification.warning({
                message: res.message
              });
            }
          }).finally(function () {
            that.confirmLoading = false;
          });
        }
      });
    },
    handleCancel: function handleCancel() {
      this.close();
    },
    // 监测因子表格相关的操作函数
    handleChangeTable: function handleChangeTable(value, key, column) {
      console.log(value);

      var newData = _toConsumableArray(this.dataItem);

      var target = newData.filter(function (item) {
        return key === item.key;
      })[0];

      if (target) {
        target[column] = value;
        this.dataItem = newData;
      }
    },
    addTable: function addTable() {
      var newData = _toConsumableArray(this.dataItem);

      console.log(_toConsumableArray(this.dataItem));
      newData.push({
        key: 'A1_' + this.addDataIndex,
        factorId: '',
        // code1: '',
        sort: '',
        editable: true
      });
      console.log(newData);
      this.addDataIndex = this.addDataIndex + 1;
      this.dataItem = newData;
      this.cacheData = newData.map(function (item) {
        return _objectSpread({}, item);
      });
    },
    delTable: function delTable(key) {
      var newData = this.dataItem.filter(function (item) {
        return key != item.key;
      });
      this.dataItem = newData;
      this.cacheData = newData.map(function (item) {
        return _objectSpread({}, item);
      });
    },
    editTable: function editTable(key) {
      var newData = _toConsumableArray(this.dataItem);

      var target = newData.filter(function (item) {
        return key === item.key;
      })[0];

      if (target) {
        target.editable = true;
        this.dataItem = newData;
      }
    },
    saveTable: function saveTable(key) {
      var newData = _toConsumableArray(this.dataItem);

      var target = newData.filter(function (item) {
        return key === item.key;
      })[0];

      if (target) {
        delete target.editable;
        this.dataItem = newData;
        this.cacheData = newData.map(function (item) {
          return _objectSpread({}, item);
        });
      }
    },
    cancelTable: function cancelTable(key) {
      var newData = _toConsumableArray(this.dataItem);

      var target = newData.filter(function (item) {
        return key === item.key;
      })[0];

      if (target) {
        Object.assign(target, this.cacheData.filter(function (item) {
          return key === item.key;
        })[0]);
        delete target.editable;
        this.dataItem = newData;
      }
    }
  }
};